module.exports = __webpack_public_path__ + "img/room-2.4c01c424.jpg";